export const JOBBOSS2 = 'jobboss2';
